// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__xxbA4","icon":"Chip_icon__R7aRI","button":"Chip_button__YValf"};